export const projectTableDefaultColumns = [
  { id: 'name', label: 'Project', isVisible: true, disabled: true, root: true },
  { id: 'description', label: 'Description', isVisible: false, disabled: false },
  { id: 'devices', label: 'Devices', isVisible: true, disabled: false },
  { id: 'users', label: 'Users', isVisible: true, disabled: false },
  { id: 'date', label: 'Date', isVisible: true, disabled: false },
  { id: 'trail', label: 'Trail', isVisible: true, disabled: false },
  { id: 'edit', label: 'Edit', isVisible: true, disabled: true, hidden: true }
];
